/**
 * main.tsx — the entry point `index.html` loads as `<script type="module">`.
 *
 * Four lines, on purpose. This file is only the module-level side effect that ties the
 * built bundle to the document, plus the stylesheet import that pulls `tokens.css`
 * into the build graph (Vite emits it as a hashed `assets/*.css` and links it from the
 * generated `dist/index.html`; without an import it would simply not ship). The CSS
 * comes first so the tokens are in the document before the first React render.
 *
 * Everything that could be asserted lives in `mount.tsx`, which is also why nothing
 * imports this file — see the coverage note there.
 */

import './styles/tokens.css';
import { mountApp } from './mount';

mountApp();
